// LLM generated - Model Claude 4 Sonnet

import { useMutation } from '@tanstack/react-query';

import type { ValidateVoucherPayload } from '~/services/wallet/wallet.service.api';
import { validateVoucher } from '~/services/wallet/wallet.service.api';
import QuickPickQueryKeys from '~/domains/contest/domains/quickPick/constants/query';

/**
 * React Query mutation hook for validating vouchers
 * Similar to useQuickPicksValidateBoost pattern
 *
 * @returns Mutation object with mutateAsync method
 *
 * @example
 * ```typescript
 * const validateVoucher = useQuickPicksValidateVoucher();
 *
 * try {
 *   await validateVoucher.mutateAsync({
 *     voucherId: "voucher-id",
 *     payload: {
 *       voucherType: "QUICKPICKS",
 *       amount: 25.5,
 *     }
 *   });
 * } catch (error) {
 *   // Handle validation error
 * }
 * ```
 */
const useQuickPicksValidateVoucher = () =>
  useMutation({
    mutationFn: (payload: ValidateVoucherPayload) => validateVoucher(payload),
    mutationKey: QuickPickQueryKeys.VALIDATE_VOUCHER(),
  });

export default useQuickPicksValidateVoucher;
